import { render, staticRenderFns } from "./S3Image.vue?vue&type=template&id=22c270b1&scoped=true"
import script from "./S3Image.vue?vue&type=script&lang=js"
export * from "./S3Image.vue?vue&type=script&lang=js"
import style0 from "./S3Image.vue?vue&type=style&index=0&id=22c270b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c270b1",
  null
  
)

export default component.exports